import React from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import SearchParamsHelper from "@/utils/SearchParamsHelper";
import Sorter, { SortItem } from "../inputs/Sorter";
import { useRouter } from "next/router";
import ContactSeller from "./ContactSeller";
import { Seller } from "@prisma/client";

export const PaginatedSellersList = ({
  currentPage,
  sellers,
  gridClass,
  queryParams,
  queryInfo,
  hasNext,
  hasPrevious,
  totalPages,
}) => {
  currentPage = currentPage ? parseInt(currentPage) : 1;
  const router = useRouter();

  const nextPageLink = hasNext
    ? SearchParamsHelper.getPageLink(currentPage + 1, queryParams)
    : null;
  const previousPageLink = hasPrevious
    ? SearchParamsHelper.getPageLink(currentPage - 1, queryParams)
    : null;

  const sortItems: SortItem[] = [];

  const sort = (sortBy: string) => {
    let params = SearchParamsHelper.setSortParam(sortBy, queryParams);
    router.push("/sellers?" + params);
  };

  const getWhatsAppText = (seller: Seller) => {
    return `Habari, nimekuona makazimapya.com. Naomba kukuulizia kuhusu nyumba/viwanja ulivyonavyo
    \n\n https://makazimapya.com/sellers/${seller.ig_name}/${seller.uuid}`;
  };

  return (
    <>
      <div className="">
        <h1 className="text-2xl font-bold">{queryInfo.pageTitle}</h1>
        <div className="sm:flex mb-5 justify-between items-center mt-2">
          <div>
            <p className="text-gray-600">{queryInfo.pageDescription}</p>
          </div>
          <div className="flex justify-end sm:mt-auto mt-3">
            {sortItems.length > 0 && (
              <Sorter
                items={sortItems}
                onSort={(value) => {
                  sort(value);
                }}
              />
            )}
          </div>
        </div>
      </div>
      {!sellers.length && (
        <div>
          Sorry, we couldn't find any seller matching your search criteria.
        </div>
      )}

      {sellers.length > 0 && (
        <>
          <div className={gridClass}>
            {sellers.map((seller: Seller, index: number) => (
              <div className="" key={index}>
                <div className="border p-4 rounded-lg" key={index}>
                  <ContactSeller
                    seller={seller}
                    whatsAppText={getWhatsAppText(seller)}
                  />
                </div>
              </div>
            ))}
          </div>
          <div className={"grid md:grid-cols-12 grid-cols-1 mt-20 mb-20"}>
            <div className="md:col-span-12 text-center">
              <nav>
                <ul className="inline-flex items-center space-x-8">
                  <li>
                    {hasPrevious && (
                      <a
                        href={"?" + previousPageLink}
                        className="w-10 h-10 inline-flex justify-center items-center mx-1 rounded-full text-slate-400 bg-white  hover:text-white shadow-sm hover:border-green-600  hover:bg-green-600 "
                        title="Previous"
                      >
                        <MdKeyboardArrowLeft className="text-[20px]" />
                      </a>
                    )}
                    {!hasPrevious && (
                      <div className="w-10 h-10 inline-flex justify-center items-center mx-1 rounded-full text-slate-400 bg-white  ">
                        <MdKeyboardArrowLeft className="text-[20px]" />
                      </div>
                    )}
                  </li>
                  <li>
                    Page {currentPage} of {totalPages}
                  </li>
                  <li>
                    {hasNext && (
                      <a
                        href={"?" + nextPageLink}
                        className="w-10 h-10 inline-flex justify-center items-center mx-1 rounded-full text-slate-400 bg-white  hover:text-white shadow-sm hover:border-green-600  hover:bg-green-600 "
                        title="Next"
                      >
                        <MdKeyboardArrowRight className="text-[20px]" />
                      </a>
                    )}
                    {!hasNext && (
                      <div className="w-10 h-10 inline-flex justify-center items-center mx-1 rounded-full text-slate-400 bg-white">
                        <MdKeyboardArrowRight className="text-[20px]" />
                      </div>
                    )}
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </>
      )}
    </>
  );
};
